export class ServerEventsStateModel {
  isConnected: boolean;
}

export class ServerEvent<T> {
  eventType: string;
  data: T;
}
